import { render, staticRenderFns } from "./Vkeyboard.vue?vue&type=template&id=e6c5bb88&scoped=true&"
import script from "./Vkeyboard.vue?vue&type=script&lang=js&"
export * from "./Vkeyboard.vue?vue&type=script&lang=js&"
import style0 from "./Vkeyboard.vue?vue&type=style&index=0&id=e6c5bb88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c5bb88",
  null
  
)

export default component.exports